import { useMemo } from "react";
import type { ConditionConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type {
  ConditionField,
  ReportField,
  RunTabularReportRequest,
  SortField,
} from "../../../../../../../../api/types/svTypes.ts";
import { isAggregation, isMeasure, isMetric } from "../../../../utilities/fieldsHelper.ts";

interface Props {
  conditions: ConditionField[];
  fields: ReportField[];
  sorting: SortField[];
  reportId: string | undefined;
  sessionId: string;
  isQueryLoggingActive: boolean | undefined;
}
export function useRequestConfigViewer({
  conditions,
  fields,
  sorting,
  reportId,
  sessionId,
  isQueryLoggingActive,
}: Props) {
  const requestConfig = useMemo(() => {
    const request: RunTabularReportRequest = {
      ...createTabularDataRequest(conditions, fields, sorting),
      reportId: reportId ?? "",
      sessionId,
      withDrilldown: true,
      useQueryLogging: isQueryLoggingActive === true,
    };
    return request;
  }, [sorting, conditions, fields, reportId, sessionId, isQueryLoggingActive]);

  return { requestConfig };
}

function createTabularDataRequest(allConditions: ConditionField[], fields: ReportField[], sorting: SortField[]) {
  const customConditions = fields
    .filter(
      (f) =>
        (isMeasure(f) || isAggregation(f) || isMetric(f)) && f.config.useCustomConditions && f.config?.customConditions
    )
    .map((f) => f.config.customConditions)
    .flat()
    .filter((c): c is ConditionConfiguration => !!c && c.parameter === true);

  const conditions = [
    ...allConditions.map((c) => ({ ...c.config, invalid: c.validation?.invalid })),
    ...customConditions,
  ].filter((c) => c.parameter === true);

  const result = { conditions, sort: sorting.map((s) => s.config) };

  return result;
}
